export default __webpack_public_path__ + "static/software-3455de7d2f63416ae9e536ab3cf36cf7.png";